import { Link } from 'react-router-dom';

import { LifeDocumentIntroHeader } from '..';
import { Button } from '../../components/basic-inputs/button';
import { useIndex } from '../../hooks';

export function AdminVideoPage() {

  const { data: videos, loading } = useIndex('videos');

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="admin-video-page screen">
      <LifeDocumentIntroHeader
        icon="description"
        title="Admin Video"
        description="Manage videos here."
      />
      {videos.map((video) => (
        <div key={video.id}>
          <h3>{video.title}</h3>
        </div>
      ))}
      <Link to="/admin/videos/new">
        <Button fullWidth>Create Video</Button>
      </Link>
    </div>
  );
}